import { cn } from "web-design-system";

export function ProgressPills({
  step,
  total,
}: {
  step: number;
  total: number;
}) {
  return (
    <div className="flex gap-1.5">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "h-1 flex-1 rounded-full transition-colors duration-300",
            i < step ? "bg-foreground" : "bg-muted-foreground/25"
          )}
        />
      ))}
    </div>
  );
}
